<template>
  <div class="steps">
      <span
         :class="{'active': currStep===1}"
         @click="() => handleSelect(steps[0].step)"
         >
         Step {{steps[0].roman}}
      </span>
      <pre>{{ currStep > 3 ? ' ··· ' : ''}}</pre>
      <span
         v-for="({roman,step}) in middleSteps"
         :key="roman"
         :class="{'active': step===currStep}"
         @click="() => handleSelect(step)"
         >
         Step {{roman}}
      </span>
      <pre>{{ 7 > currStep ? ' ··· ' : ''}}</pre>
      <span
         :class="{'active': currStep===9}"
         @click="() => handleSelect(steps[8].step)"
         >
         Step {{steps[8].roman}}
      </span>
   </div>
</template>

<script>

export default {
   data()
   {
      return {
         currStep: 1,
         steps: [
            { roman: "I",    step: 1},
            { roman: "II",   step: 2},
            { roman: "III",  step: 3},
            { roman: "IV",   step: 4},
            { roman: "V",    step: 5},
            { roman: "VI",   step: 6},
            { roman: "VII",  step: 7},
            { roman: "VIII", step: 8},
            { roman: "IX",   step: 9},
         ],
      };
   },
   props: {
      step: {
         type: Number,
         required: true,
         validator: value => value >= 1 && value <= 9,
      }
   },
   created()
   {
      this.currStep = this.step;
   },
   computed: {
      middleSteps() {
         if (this.currStep < 3)
            return this.steps.slice(1, 4);
         if (this.currStep > 7)
            return this.steps.slice(-4,-1)
         
         const currIndex = this.currStep-1;
         return this.steps.slice(currIndex-1, currIndex+2)
      }
   },
   methods: {
      handleSelect(step)
      {
         console.log("handle step selection here");
         // this.currStep = step;
         this.$emit('select-step', step);
      }
   }
}
</script>

<style lang="scss" scoped>
.steps {
   border-top: 1px solid lightgrey;
   padding: 2px 2px;
   background: darken(white, 2%);
   display: flex;
   justify-content: space-between;
   align-items: center;
   font-size: 0.88em;
   flex-wrap: wrap;
   font-weight: 900;
   
   > span {
      font-weight: 400;
      padding: 0.3em 0em;
      position: relative;
      // cursor: pointer;
      text-align: center;
      filter: drop-shadow(0 0 1px rgba($primary-color,1));
      flex: 1;
      $pointiness: 7%;
      $right-point: 100%-$pointiness;
      &:not(:first-child) {
         margin-left: -1%;
      }
      &::before {
         position: absolute;
         top: 0;
         left: 0;
         bottom: 0;
         right: 0;
         background: white;
         content: "";
         clip-path: polygon(0 0, $right-point 0%, 100% 50%, $right-point 100%, 0 100%, $pointiness 50%);
         z-index: -1;
      }
      &:first-child::before {
         clip-path: polygon($right-point 0, 100% 50%, $right-point 100%, 0 100%, 0 0);
      }
      &:last-child::before {
         clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%, $pointiness 50%);
      }
      &.active {
         position: relative;
         z-index: 0;
         color: white;
         &::before {
            background: $primary-color;
         }
      }
   }
}
</style>